import { connect } from 'react-redux';
import { getAuthIsLoggedIn } from 'modules/auth/selectors';
import PublicRoute from './public-route';

const mapStateToProps = (state) => ({
  isLoggedIn: getAuthIsLoggedIn(state),
});

export default connect(mapStateToProps)(PublicRoute);
